var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocbayLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 144,
    viewBox: "0 0 240 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_28495_5638)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_28495_5638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M119.993 96C146.502 96 167.993 74.5097 167.993 48C167.993 21.4903 146.502 0 119.993 0C93.4829 0 71.9926 21.4903 71.9926 48C71.9926 74.5097 93.4829 96 119.993 96Z",
    fill: "#6BE4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.756 93.9936C133.756 93.9936 113.481 92.7744 113.481 75.8304V54.5088H167.558C167.548 54.5088 164.947 84.0768 133.756 93.9936Z",
    fill: "url(#paint0_linear_28495_5638)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.0044 61.7664C74.0044 61.7664 75.2236 41.4912 92.1676 41.4912H113.489V95.568C113.489 95.5584 83.9212 92.9568 74.0044 61.7664Z",
    fill: "url(#paint1_linear_28495_5638)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.222 2.00635C106.222 2.00635 126.497 3.22555 126.497 20.1695V41.4911H72.4302C72.4302 41.4911 75.0318 11.9231 106.222 2.00635Z",
    fill: "url(#paint2_linear_28495_5638)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.989 34.2334C165.989 34.2334 164.77 54.5086 147.826 54.5086H126.504V0.441406C126.504 0.441406 156.072 3.04301 165.989 34.2334Z",
    fill: "url(#paint3_linear_28495_5638)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.486 75.8307V57.7731C113.486 55.9683 112.027 54.5091 110.222 54.5091H92.1646V41.4915H110.222C112.027 41.4915 113.486 40.0323 113.486 38.2275V20.1699H126.513V38.2275C126.513 40.0323 127.973 41.4915 129.777 41.4915H147.835V54.5187H129.777C127.973 54.5187 126.513 55.9779 126.513 57.7827V75.8403H113.486V75.8307Z",
    fill: "#032530"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M45.5426 109.714H55.8826C63.6585 109.714 69.6275 115.011 69.6275 124.427C69.6275 133.842 63.6585 139.139 55.8826 139.139H45.5426V109.714ZM55.8826 137.247C62.1885 137.247 67.2736 132.876 67.2736 124.427C67.2736 115.977 62.1871 111.648 55.8826 111.606H47.7281V137.247H55.8826Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.6505 127.58C72.6505 120.014 77.6521 115.642 83.8313 115.642C90.0105 115.642 95.0121 120.013 95.0121 127.58C95.0121 135.147 90.0105 139.518 83.8313 139.518C77.6521 139.518 72.6505 135.147 72.6505 127.58ZM92.7848 127.58C92.7848 121.19 88.876 117.492 83.8313 117.45C78.7866 117.408 74.8778 121.19 74.8778 127.58C74.8778 133.969 78.7866 137.753 83.8313 137.711C88.876 137.668 92.7848 133.969 92.7848 127.58Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.0895 127.538C98.0895 120.518 102.25 115.642 109.27 115.642C115.66 115.642 119.148 119.804 119.653 124.847H117.426C117.132 120.897 114.273 117.448 109.272 117.448C103.723 117.448 100.318 121.611 100.318 127.537C100.318 133.799 104.227 137.709 109.272 137.709C114.316 137.709 116.964 133.884 117.426 130.773H119.653C119.065 135.356 115.449 139.516 109.27 139.516C102.587 139.516 98.0895 134.767 98.0895 127.537V127.538Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.57 130.858C150.57 136.028 146.199 139.139 140.818 139.139H128.796V109.714H140.314C144.643 109.714 148.468 112.447 148.468 117.238C148.468 120.265 146.535 122.492 143.677 123.418C147.713 124.175 150.57 126.781 150.57 130.858ZM130.982 111.606V122.662H139.346C143.382 122.662 146.115 120.645 146.115 117.24C146.115 113.835 143.55 111.606 139.809 111.606H130.982ZM148.216 130.858C148.216 126.949 145.022 124.552 140.187 124.552H130.982V137.247H140.356C144.853 137.247 148.216 134.557 148.216 130.858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.451 137.373V139.138H173.854C171.711 139.138 170.408 137.835 170.408 135.606V133.001C169.315 137.12 165.742 139.557 161.454 139.557C156.957 139.557 153.762 136.951 153.762 132.495C153.762 128.376 156.453 125.518 162.127 125.518H165.153C168.81 125.518 170.154 124.426 170.154 122.365C170.154 119.297 167.632 117.447 163.933 117.447C159.981 117.447 157.207 119.549 156.83 123.5H154.644C155.065 118.455 158.596 115.639 163.935 115.639C169.273 115.639 172.384 118.54 172.384 122.828V135.355C172.384 136.657 172.932 137.372 174.15 137.372H175.452L175.451 137.373ZM170.281 124.804H170.239C169.65 126.443 167.969 127.368 164.943 127.368H162.21C157.629 127.368 156.031 130.017 156.031 132.497C156.031 135.146 157.754 137.71 161.748 137.71C165.952 137.71 170.281 134.894 170.281 128.378V124.804Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.451 116.019L183.102 145.108C182.808 145.822 182.134 146.285 181.21 146.285H174.021V144.519H181.167L183.773 137.878L175.113 116.02H177.425L184.824 135.482L192.137 116.02H194.449L194.451 116.019Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.898 123.417V109.736H202.325V115.971H209.772V109.736H211.198V123.417H209.772V117.222H202.325V123.417H200.898Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.54 120.583L224.322 123.417H222.856L222.211 121.033C221.488 118.375 220.725 117.515 218.771 117.515H215.448V123.417H214.021V109.736H219.064C221.996 109.736 223.892 111.358 223.892 113.625C223.892 115.306 222.797 116.44 220.979 116.948C222.387 117.515 223.051 118.766 223.54 120.583ZM215.448 110.987V116.264H218.849C220.96 116.264 222.406 115.345 222.406 113.625C222.406 111.944 221.038 110.987 219.045 110.987H215.448Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_28495_5638",
    x1: 113.481,
    y1: 74.2569,
    x2: 167.558,
    y2: 74.2569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0989A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.317708,
    stopColor: "#2FBAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6BE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_28495_5638",
    x1: 93.7468,
    y1: 41.4912,
    x2: 93.7468,
    y2: 95.568,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0989A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2FBAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6BE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_28495_5638",
    x1: 126.497,
    y1: 21.7431,
    x2: 72.4302,
    y2: 21.7431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0989A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2FBAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6BE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE4FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_28495_5638",
    x1: 146.252,
    y1: 54.5086,
    x2: 146.252,
    y2: 0.441406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#0989A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#2FBAD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#6BE4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6BE4FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_28495_5638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 240,
    height: 144,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_28495_5638"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white",
    transform: "translate(71.9966)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocbayLogo);
export default __webpack_public_path__ + "static/media/docbay-logo.c29e7db02a13a389a84172ba8381a47a.svg";
export { ForwardRef as ReactComponent };